const SYMBOL = { USD: '$', GBP: '£', EUR: '€' };
/** "PKR 186,000", "SAR 14,500", "$1,250". Whole numbers unless the amount has cents. */
export function formatMoney(amount, currency, opts = {}) {
    const neg = amount < 0;
    const abs = Math.abs(amount);
    let n;
    if (opts.compact && abs >= 1_000_000)
        n = (abs / 1_000_000).toFixed(2).replace(/\.?0+$/, '') + 'M';
    else if (opts.compact && abs >= 100_000)
        n = Math.round(abs / 1000).toLocaleString('en-US') + 'K';
    else
        n = abs.toLocaleString('en-US', { maximumFractionDigits: abs % 1 ? 2 : 0 });
    const s = SYMBOL[currency];
    const body = s ? `${s}${n}` : `${currency} ${n}`;
    const sign = neg ? '−' : opts.sign ? '+' : '';
    return sign + body;
}
export function formatNumber(n, digits = 0) {
    return n.toLocaleString('en-US', { maximumFractionDigits: digits });
}
/** Pakistan pays into the Pakistan account, the UAE into the UAE account, Saudi Arabia and everyone else into the Saudi account. */
export function accountFor(country) {
    const c = (country || '').toUpperCase();
    if (c === 'PK')
        return 'PK';
    if (c === 'AE')
        return 'AE';
    return 'SA';
}
export const ACCOUNT_LABEL = { PK: 'Pakistan account', AE: 'UAE account', SA: 'Saudi account' };
export function initials(name) {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    return ((parts[0]?.[0] ?? '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
}
/** SMH Global Services' company for each bank account (as in 1.1's emails and invoices). */
export const PAY_TO = {
    PK: 'SMH Global Services (Private) Limited',
    AE: 'SMH Global Services L.L.C-FZ',
    SA: 'SMH Global Services Company',
};
/** Customers in these countries see and pay plan prices in their own money; everyone else in USD (as in 1.1). */
export const PRICE_CURRENCY = { PK: 'PKR', SA: 'SAR', AE: 'AED', QA: 'QAR' };
export function priceCurrency(country) {
    return PRICE_CURRENCY[(country || '').toUpperCase()] ?? 'USD';
}
//# sourceMappingURL=money.js.map